'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _inputarea = require('../inputarea/inputarea.vue');

var _inputarea2 = _interopRequireDefault(_inputarea);

var _msgBar = require('../msg-bar/msg-bar.vue');

var _msgBar2 = _interopRequireDefault(_msgBar);

var _scrollJs = require('scroll-js');

var _scrollJs2 = _interopRequireDefault(_scrollJs);

var _tracker = require('../../assets/js/tracker.js');

var _tracker2 = _interopRequireDefault(_tracker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        inputArea: _inputarea2.default,
        msgBar: _msgBar2.default
    },
    data: function data() {
        return {
            hasResults: false,
            resultData: {},
            inputData: {},
            scroll: null,
            resultAreaReady: false
        };
    },

    events: {
        'resultareaready': function resultareaready() {
            this.resultAreaReady = true;
        },
        'calcresult': function calcresult(data) {
            if (data) {
                this.hasResults = true;
                this.resultData = data;
                this.$broadcast('reset');

                var self = this;
                setTimeout(function () {
                    self.scroll.toElement(self.$els.results, { duration: 500 });
                }, 500);
            } else {
                this.hasResults = false;
                this.resultData = {};
            }
        },
        'calcinput': function calcinput(inputData) {
            this.inputData = inputData;
        }
    },
    ready: function ready() {
        this.scroll = new _scrollJs2.default(document.body);
        var self = this;
        window.onscroll = function () {
            if (window.innerHeight + window.scrollY >= document.body.offsetHeight) {
                if (self.hasResults) {
                    _tracker2.default.trackEvent('scroll', 'User reached bottom of page', '');
                }
            }
        };
    },

    methods: {
        appClick: function appClick(evt) {
            this.$broadcast('appclick', evt);
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "<div class=app-container @click=appClick><input-area :result-area-ready=resultAreaReady></input-area><result-area v-if=hasResults :result-data=resultData :input-data=inputData v-el:results=\"\"></result-area></div><msg-bar></msg-bar>"
